// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/bookmark-check.js';

import { paths } from '../generated/bookmark-check';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('bookmark-check', Original, paths);
